module.exports = __webpack_public_path__ + "templates-59e97cd7/template-5-2x-bc170faebb43de630703071cc640fa2a.jpg";